import { getBackendUrl } from "@Utils";
import { estimateMeasurementsUrl, portalMeasurementUnitsUrl } from "@Services/dataManager";
import axiosWrapper from "../services/axiosWrapper";
import { userSettingsType } from "../services/constants";
import _ from "lodash";
import { getNumberBasedOnSettings } from "@Services/utils/helpers";
import i18n from "@i18n";
const { t } = i18n;

export const DSR_LEVEL_MEASUREMENT_UNIT = "dsr_level_unit";
export const ESTIMATE_LEVEL_MEASUREMENT_UNIT = "estimate_level_unit";
export const SYSTEM_GENERATED_UNIT = "SYSTEM GENERATED";

export const estimateGeneralSettingFields = {
  PREFERENCES: "Preferences",
  UNITS: "Units",
};

export const decimalPlacesDataSource = [
  { text: 0, value: 0 },
  { text: 1, value: 1 },
  { text: 2, value: 2 },
  { text: 3, value: 3 },
  { text: 4, value: 4 },
];
export const digitGroupingDataSource = [
  { text: "Indian Format", value: "Indian", example: "12,34,567" },
  { text: "International Format", value: "International", example: "1,234,567" },
  { text: "No grouping", value: "none", example: "1234567" },
];
export const largeNumberAbbreviationDataSource = [
  { text: "Thousands, Millions, Billions ", value: "KMB", symbol: "K,M,B" },
  { text: "Lakhs, Crores ", value: "LCr", symbol: "L,Cr" },
  { text: "None", value: "none" },
];

export const getEditBOQItemsTabs = () => ({
  DETAILS: { text: t("Details"), value: "DETAILS" },
  QUANTITY: { text: t("Quantity"), value: "QUANTITY" },
  UNIT: { text: t("Unit"), value: "UNIT" },
  RATE: { text: t("Rate"), value: "RATE" },
  AMOUNT: { text: t("Amount"), value: "AMOUNT" },
});

export const measurementSources = {
  MEASUREMENTS: "measurements",
  TAKEOFFS: "takeoffs",
  ESTIMATE: "estimate",
  TAKEOFF_SIDEBAR: "takeoff_sidebar",
  REFERENCE_MEASUREMENT: "reference",
};

export const takeoffWizardResultsErrors = {
  VALUE_MISSING: "Value Missing",
  ITEM_NOT_FOUND: "Cost Database item does not exist",
  UNIT_MISMATCH: "Unit doesn’t match with Item’s expected Measurement Unit",
  INVALID_PARAMETER: "Invalid parameter value",
  DUPLICATE_PARAMETER: "Duplicate parameters exist",
};

export const numberingSystemOptions = [
  {
    item: "1, 2, 3",
    value: 0,
  },
  {
    item: "a, b, c",
    value: 1,
  },
  {
    item: "A, B, C",
    value: 2,
  },
  {
    item: "i, ii, iii",
    value: 3,
  },
  {
    item: "I, II, III",
    value: 4,
  },
];

export const takeoffSources = { VIEWER: "viewer", ESTIMATE: "estimate" };

export const itemListSources = {
  COST_DATABASE: "costDatabase",
  ESTIMATE: "estimate",
  ADD_ITEM_POPUP: "addItemToBoq",
  LINK_BOQ_ITEMS: "linkBoqItems",
  PREVIEW_BOQ_ITEMS: "previewBoqItems",
  CONTRACT_CDB: "contractCDB",
  BOQ_PRINT: "boqPrint",
  ESTIMATE_ATTACHED_CD_PREVIEW: "estimateCDPreview",
};

export const unitTypesList = [
  { title: "LINEAR", value: "linear", name: "Linear" },
  { title: "AREA", value: "area", name: "Area" },
  { title: "VOLUME", value: "volume", name: "Volume" },
  { title: "COUNT", value: "count", name: "Count" },
];

export const unitTypes = {
  LINEAR: { value: "Linear", name: "Length" },
  AREA: { value: "Area", name: "Area" },
  VOLUME: { value: "Volume", name: "Volume" },
  COUNT: { value: "Count", name: "Count" },
};

export const twoDOperators = [
  {
    id: "c1",
    title: unitTypes.COUNT.value,
    text: "Count object by clicking on the plan to place a symbol",
  },
  {
    id: "l1",
    title: unitTypes.LINEAR.value,
    text: "Measure a distance by clicking on each point",
  },
  {
    id: "a1",
    title: unitTypes.AREA.value,
    text: "Measure a flat area by clicking on each corner",
  },
  {
    id: "v1",
    title: unitTypes.VOLUME.value,
    text: "Enter the depth and measure volume by clicking on each corner",
  },
];

export const threeDOperators = [
  {
    id: "o1",
    title: "objects",
    text: "Measure object parameter by clicking on the object",
  },
  {
    id: "s1",
    title: "surface",
    text: "Measure distance/area by clicking on the surface",
  },
  {
    id: "e1",
    title: "edge",
    text: "Measure distance by clicking on the edges",
  },
  {
    id: "p1",
    title: "point",
    text: "Count points by clicking on the surface to place a symbol",
  },
];

export const getMeasurementDetails = (_name: any) => {
  let result: any = { type: null, name: null, units: null };

  switch (_name) {
    case "QTakeOffLengthMarkup":
    case "QTakeOffLengthWithBreakMarkup":
    case "QTakeOffCircumferenceMarkup":
    case "LinearDropMarkup":
    case "SlopeLengthMarkup":
    case "QTakeOffThreePtArcLengthMarkup":
      result = { type: unitTypes.LINEAR.value, name: unitTypes.LINEAR.name };
      break;

    case "QTakeOffAreaMarkup":
    case "SlopeAreaMarkup":
    case "SurfaceAreaDeductionMarkup":
    case "SurfaceAreaDeductionDepthMarkup":
    case "QTakeOffCircleAreaMarkup":
    case "Surface Area":
    case "QTakeOffThreePtArcAreaMarkup":
      result = { type: unitTypes.AREA.value, name: unitTypes.AREA.name };
      break;

    case "TwoDVolumeMarkup":
    case "OneDVolumeMarkup":
      result = { type: unitTypes.VOLUME.value, name: unitTypes.VOLUME.name };
      break;

    case "QTakeOffCountMarkup":
      result = { type: unitTypes.COUNT.value, name: unitTypes.COUNT.name };
      break;

    default:
      break;
  }
  return result;
};

export const countSymbols = [
  { name: "TRIANGLE", value: 0 },
  { name: "SQUARE", value: 1 },
  { name: "PENTAGON", value: 2 },
  { name: "HEXAGON", value: 3 },
  { name: "OCTAGON", value: 4 },
];

export const hexToRgb = (h: any) => {
  let r: any = 0;
  let g: any = 0;
  let b: any = 0;

  if (h.length === 4 || h.length === 5) {
    r = `0x${h[1]}${h[1]}`;
    g = `0x${h[2]}${h[2]}`;
    b = `0x${h[3]}${h[3]}`;
  }

  if (h.length === 7 || h.length === 9) {
    r = `0x${h[1]}${h[2]}`;
    g = `0x${h[3]}${h[4]}`;
    b = `0x${h[5]}${h[6]}`;
  }

  return { red: Number.parseInt(r), green: Number.parseInt(g), blue: Number.parseInt(b) };
};

export const getDisplayQuantity = ({ quantity, factor, rate }: any): any => {
  const output: any = {};
  output.quantity = factor && quantity ? quantity / factor : quantity;
  output.amount = quantity && rate && output.quantity * rate;

  return output;
};

export const getDefaultQuantity = ({ quantity, factor }: any) => {
  if (factor && quantity) {
    const value = String(quantity * factor);
    return Number.parseFloat(value);
  }

  return quantity;
};

export const correctDecimalPlaces = ({ value, decimals }: any) => {
  if (!value) return value;
  if (typeof decimals !== "number") decimals = 2;

  return Number.parseFloat(Number.parseFloat(value).toFixed(decimals));
};

export const loadMarkupStylesViewer = ({
  viewerImpl,
  viewerMarkup,
  lineThickness,
  lineColor,
  fillColor,
  fillOpacity,
  symbolSize,
  countSymbol,
}: any) => {
  if (!viewerMarkup) return;

  const setAttribute = (setter: any, value: any, viewerMarkup: any) => {
    if (viewerMarkup[setter] && value !== undefined) {
      viewerMarkup[setter](value);
    }
  };

  setAttribute("setStrokeWidth", lineThickness, viewerMarkup);
  setAttribute("setStrokeColor", lineColor, viewerMarkup);
  setAttribute("setFillColor", fillColor, viewerMarkup);
  setAttribute("setFillOpacity", fillOpacity, viewerMarkup);
  setAttribute("setMarkupSize", symbolSize, viewerMarkup);
  setAttribute("setMarkupShape", countSymbol, viewerMarkup);

  if (viewerImpl) {
    viewerImpl.hwv.markupManager.refreshMarkup();
  }
};

export const prepareMarkupColor = (color: any) => {
  const rgbColor = hexToRgb(color);
  return new Communicator.Color(rgbColor.red, rgbColor.green, rgbColor.blue);
};

export const prepareTakeoffColors = ({ takeoffLineColor, takeoffFillColor }: any) => {
  const lineColorRGB = takeoffLineColor ? hexToRgb(takeoffLineColor) : null;
  const lineColor = lineColorRGB
    ? new Communicator.Color(lineColorRGB.red, lineColorRGB.green, lineColorRGB.blue)
    : null;
  const fillColorRGB = takeoffFillColor ? hexToRgb(takeoffFillColor) : null;
  const fillColor = fillColorRGB
    ? new Communicator.Color(fillColorRGB.red, fillColorRGB.green, fillColorRGB.blue)
    : null;
  return { lineColor, fillColor };
};

import {
  setMeasurementsData,
  setTakeoffsList,
  setTakeoff,
  setMeasurementsModalStatus as setMeasurementsModalStatusReducer,
} from "../reducers/measurements";
import {
  setAdditionalCost as setAdditionalCostAction,
  setEstimateAdditionalCostTotal as setAdditionalCostTotalAction,
} from "../reducers/EstimateList";
import { setCostDatabase as setCostdatabaseAction } from "../reducers/DsrReducer";

export { setEstimateFieldsNeedtoRefresh as setEstimateFieldNeedToRefresh } from "../reducers/EstimateList";

export const prepareEstimationFieldNeedToRefresh = ({
  estimateFieldsNeedToRefresh,
  HoopsModalStatus,
  takeoffs,
  measurements,
}: any) => {
  const data = { ...estimateFieldsNeedToRefresh };
  if (_.get(HoopsModalStatus, "Takeoffs.show") && takeoffs) {
    data.takeoffs = takeoffs;
  }
  if (_.get(HoopsModalStatus, "Measurements.show") && measurements !== undefined) {
    data.measurements = measurements;
  }

  return data;
};

export const changeEstimateUnits = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/changeDisplayUnit`, data);
  return response;
};

export const canUpdateMeasurementUnitType = async ({ _id }: any) => {
  const data = { _id };
  const response = await axiosWrapper.post(`${getBackendUrl()}/units/canUpdateMeasurementUnitType`, data);
  return response;
};

export const createNewEstimate = async ({ name, description, costIndex, spaceId, projectId }: any) => {
  const data = {
    action: "insert",
    value: {
      name,
      description,
      costIndex,
      spaceId,
      projectId,
    },
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateList`, data);
  return response;
};

export const deleteEstimate = async ({ estimateId }: any) => {
  const data = {
    key: estimateId,
    action: "remove",
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateList`, data);
  return response;
};

export const saveItemMeasurementUnit = async ({
  itemId,
  measurementUnitId,
  conversionRatePU,
  conversionRateMU,
  resourceLevel,
  resourceId,
}: any) => {
  const data = {
    itemId,
    measurementUnitId,
    conversionRate: conversionRatePU.concat(":", conversionRateMU),
    resourceLevel,
    resourceId,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/units/saveItemMeasurementUnit`, data);
  return response;
};

export const syncItemMeasurementUnit = async ({ itemId, resourceLevel, resourceId, dsrVersionId }: any) => {
  const data = {
    itemId,
    resourceLevel,
    resourceId,
    dsrVersionId,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/units/syncItemMeasurementUnit`, data);
  return response;
};

export const getDsrItem = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/getDsrItem`, data);
  return response;
};

export const getEstimateItem = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateItem`, data);
  return response;
};

export const deleteItemsFromTakeoffs = async ({ data, estimateId }: any) => {
  const payload = { data, estimateId };
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/removeItemsFromTakeoffs`, payload);
  return response;
};

export const addFilesToEstimate = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/addFilesToEstimate`, data);
  return response;
};

export const removeFilesFromEstimate = async (fileVersionId: any, estimateId: any) => {
  const data = {
    key: fileVersionId,
    action: "remove",
    params: {
      estimateId,
    },
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateFiles`, data);
  return response;
};

export const getTakeoffsList = async ({ estimateId, excludeMeasurements = null, type, versionId }: any) => {
  const data = {
    value: { params: { estimateId, excludeMeasurements, versionId, type } },
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/getTakeoffsList`, data);
  return response;
};

export function getTakeoffsListData({ estimateId, excludeMeasurements = null, versionId, skipSystemGenerated }: any) {
  return async (dispatch: any) => {
    const data = {
      value: { params: { estimateId, excludeMeasurements, versionId, skipSystemGenerated } },
    };
    const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/getTakeoffsList`, data);
    if (!response.data.status) return;
    dispatch(setTakeoffsList(response.data.result));
    return response.data.result;
  };
}

export const getTakeoff = async ({ takeOffItemId, versionId, estimateId }: any) => {
  const data = { takeOffItemId, versionId, estimateId };
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/getTakeoff`, data);
  return response;
};

export function getTakeoffData({ takeOffItemId, versionId, estimateId }: any) {
  return async (dispatch: any) => {
    const data = { takeOffItemId, versionId, estimateId };
    const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/getTakeoff`, data);
    if (!response.data.status) return;

    const takeoffData = response.data.result;
    const saveData = {
      ...takeoffData,
      quantity: getDisplayQuantity({
        quantity: takeoffData.quantity,
        factor: takeoffData.factor,
      }).quantity,
      additionalQuantity: getDisplayQuantity({
        quantity: takeoffData.additionalQuantity,
        factor: takeoffData.factor,
      }).quantity,
    };

    dispatch(setTakeoff(saveData));
    return saveData;
  };
}

export function setTakeoffData(data: any) {
  return (dispatch: any) => dispatch(setTakeoff(data));
}

export const createTakeoff = async ({ name, description, type, estimateId }: any) => {
  const data = {
    name,
    description,
    type,
    estimateId,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/createTakeoff`, data);
  return response;
};
export const getBoqData = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/getBoqData`, data);
  return response;
};

export const getEstimateItemsList = async ({ source, versionId, parentId, dsrId, estimateId, skip, take }: any) => {
  const params: any = {
    value: {
      requiresCounts: true,
    },
  };
  if (parentId) {
    params.value.where = [
      {
        field: "parentId",
        ignoreCase: false,
        isComplex: false,
        operator: "equal",
        value: parentId,
      },
    ];
  }
  if (skip) {
    params.value.skip = skip;
  }
  if (take) {
    params.value.take = take;
  }

  let response;
  if (source === itemListSources.ESTIMATE) {
    params.value.params = {
      estimateId,
      versionId,
    };
    response = await getEstimateItems(params);
  } else if (source === itemListSources.COST_DATABASE) {
    params.value.params = {
      dsrId,
      versionId,
    };
    response = await getCostDatabaseItems(params);
  }
  return response;
};

export const getEstimateItems = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateItems`, data);
  return response;
};

export const getCostDatabaseItems = async (data: any) => {
  const responseData = await axiosWrapper.post(`${getBackendUrl()}/dsr/getAllDsrItems`, data);
  return responseData;
};

export const updateTakeoff = async ({
  takeOffItemId,
  name,
  description,
  additionalQuantity,
  estimateId,
  units,
  factor,
  lineColor,
  lineThickness,
  fillColor,
  fillOpacity,
  symbolSize,
  countSymbol,
}: any) => {
  additionalQuantity = getDefaultQuantity({
    factor,
    quantity: Number.parseFloat(additionalQuantity),
  });
  const data = {
    action: "update",
    value: {
      takeOffItemId,
      name,
      description,
      additionalQuantity,
      unitsId: units,
      lineColor,
      lineThickness: Number.parseFloat(lineThickness),
      fillColor,
      fillOpacity: Number.parseFloat(fillOpacity),
      symbolSize: Number.parseFloat(symbolSize),
      countSymbol: Number.parseFloat(countSymbol),
    },
    params: { estimateId },
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/getTakeoffsList`, data);
  return response;
};

export const deleteTakeoff = async ({ takeOffItemId, estimateId }: any) => {
  const data = { action: "remove", key: takeOffItemId, params: { estimateId } };
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/getTakeoffsList`, data);
  return response;
};

export const duplicateTakeoff = async ({
  takeOffItemId,
  name,
  description,
  type,
  linkMeasurements,
  linkItems,
  estimateId,
}: any) => {
  const data = {
    takeOffItemId,
    estimateId,
    name,
    description,
    type,
    linkMeasurements,
    linkItems,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/duplicateTakeoff`, data);
  return response;
};

export const duplicateItemInTakeoff = async ({ itemId, takeOffItemId, estimateId }: any) => {
  const data = { itemId, takeOffItemId, estimateId };
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/duplicateItemInTakeoff`, data);
  return response;
};

export const addItemsToTakeoffs = async (data: any, shouldReturnResult = true) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/addItemsToTakeoffs`, data);
  if (shouldReturnResult) {
    return response;
  }
};

export const addMeasurementsToTakeoffs = async (data: any, shouldReturnResult = true) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/measurements/addMeasurementsToTakeoffs`, data);
  if (shouldReturnResult) {
    return response;
  }
};

export const removeMeasurementsFromTakeoffs = async (data: any, shouldReturnResult = true) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/measurements/removeMeasurementsFromTakeoffs`, data);
  if (shouldReturnResult) return response;
};

export function setMeasurementsModalStatus({ status }: any) {
  if (status !== true && status !== false) return;
  return async (dispatch: any) => dispatch(setMeasurementsModalStatusReducer({ status }));
}

export const addMeasurementsToTakeoffsFromNodes = async (data: any) =>
  await axiosWrapper.post(`${getBackendUrl()}/measurements/addMeasurementsToTakeoffsFromNodes`, data);

export const createMeasurement = async ({
  measurementId,
  name,
  type,
  quantity,
  units,
  takeOffItemId,
  scale,
  markup,
  fileVersionId,
  estimateId,
  elements,
  nestedMeasurements,
  referenceMeasurements,
  manualUnit,
  formula,
  isManualMeasurement,
  sheetId,
}: any) => {
  const data = {
    measurementId,
    name,
    type,
    quantity,
    units,
    takeOffItemId,
    scale,
    markup,
    fileVersionId,
    estimateId,
    elements,
    nestedMeasurements,
    referenceMeasurements,
    manualUnit,
    formula,
    isManualMeasurement,
    sheetId,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/measurements/createMeasurement`, data);
  return response;
};

export const updateMeasurement = async (params: any) => {
  const data = {
    action: "update",
    value: params,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/measurements/getMeasurements`, data);
  return response;
};

export const duplicateMeasurement = async ({ measurementId, estimateId, linkTakeoffs }: any) => {
  const data = {
    measurementId,
    estimateId,
    linkTakeoffs,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/measurements/duplicateMeasurement`, data);
  return response;
};

export const updateMeasurementTags = async ({ measurementId, tags, estimateId }: any) => {
  const data = { measurementId, tags, estimateId };
  const response = await axiosWrapper.post(`${getBackendUrl()}/measurements/updateMeasurementTags`, data);
  return response;
};

export function getMeasurements({ estimateId, sheetId, takeOffItemId, fileVersionId, versionId }: any) {
  return async (dispatch: any) => {
    const data = {
      value: {
        params: {
          estimateId,
          sheetId,
          takeOffItemId,
          fileVersionId,
          versionId,
        },
      },
    };
    const response = await axiosWrapper.post(`${getBackendUrl()}/measurements/getMeasurements`, data);
    if (response.data.status) {
      dispatch(setMeasurementsData(response.data.result));
    }
  };
}

export function setMeasurements(data: any) {
  return (dispatch: any) => {
    dispatch(setMeasurementsData(data));
  };
}

export const deleteMeasurement = async ({ key, action, estimateId }: any) => {
  const data = { key, action, params: { estimateId } };
  const response = await axiosWrapper.post(`${getBackendUrl()}/measurements/getMeasurements`, data);
  return response;
};

export function getAdditionalCost({ estimateId, versionId }: any) {
  return async (dispatch: any) => {
    const data = { estimateId, versionId };
    const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getAdditionalCost`, data);
    if (response.data.status) {
      dispatch(setAdditionalCostAction(response.data.data));
    }
  };
}

export async function deleteAdditionalCost({ uniqueIds, estimateId }: any) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getAdditionalCost`, {
    value: uniqueIds,
    key: estimateId,
    action: "remove",
  });
  return response;
}

export const saveAdditionalCost = async ({ estimateId, name, value, uniqueId, manualMeasurementSheet }: any) => {
  const data = {
    estimateId,
    name,
    value,
    uniqueId,
    manualMeasurementSheet,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/saveAdditionalCost`, data);
  return response;
};

export const createQuery = async ({ fileVersionId, estimateId, query = "{}", name }: any) => {
  const data = {
    value: { fileVersionId, estimateId, query, name },
    action: "insert",
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/queries/queriesData`, data);
  return response;
};

export const getQueryData = async ({ fileVersionId, id }: any) => {
  const data = { value: { params: { fileVersionId, id } } };
  const response = await axiosWrapper.post(`${getBackendUrl()}/queries/queriesData`, data);
  return response;
};

export const updateQuery = async ({ id, name, queryRule }: any) => {
  const value: any = { id };
  if (name) value.name = name;
  if (queryRule) value.queryRule = queryRule;

  const data = { action: "update", value };
  const response = await axiosWrapper.post(`${getBackendUrl()}/queries/queriesData`, data);
  return response;
};

export const deleteQueries = async ({ ids }: any) => {
  const data = { action: "remove", value: { ids } };
  const response = await axiosWrapper.post(`${getBackendUrl()}/queries/queriesData`, data);
  return response;
};

export const saveItemVariableRate = async ({ itemId, variableRate, dsrId }: any) => {
  const data = {
    itemId,
    variableRate,
    dsrId,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/saveItemVariableRate`, data);
  return response;
};

export const saveItemRangeUnitValue = async ({ itemId, estimateId, rangeUnitValue }: any) => {
  const data = {
    action: "update",
    value: { itemId, rangeUnitValue },
    params: { estimateId },
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateItems`, data);
  return response;
};

export const saveItemAdditionalAmount = async ({ itemId, additionalAmount, estimateId }: any) => {
  const data = {
    action: "update",
    value: { itemId, additionalAmount },
    params: { estimateId },
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateItems`, data);
  return response;
};

export const saveItemDetails = async (data: any) => {
  const responseData = await axiosWrapper.post(`${getBackendUrl()}/estimate/saveItemDetails`, data);
  return responseData;
};

export const saveItemCostIndexValue = async ({ itemId, estimateId, costIndex }: any) => {
  const data = {
    action: "update",
    value: { itemId, costIndex },
    params: { estimateId },
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateItems`, data);
  return response;
};

export const getEstimateVersionInfo = async ({ estimateId }: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateVersion`, {
    estimateId,
  });
  return response;
};

export const createEstimateVersion = async ({ estimateId }: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/createEstimateVersion`, {
    estimateId,
  });
  return response;
};

export const restoreEstimateVersion = async ({ estimateId, restoreEstimateVersionId }: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/restoreEstimateVersion`, {
    estimateId,
    restoreEstimateVersionId,
  });
  return response;
};

export const saveEstimateItemsFromExcelSheet = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/saveEstimateItemsFromExcelSheet`, data);
  return response;
};

export const importCostDatabaseItemsFromExcelSheet = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/saveCostDatabaseItemsFromExcelSheet`, data);
  return response;
};

export const changeDsrVersionAttachedToEstimate = async ({
  _id,
  upgradeDsrVersion = true,
  forceDeletedItemToManual,
}: any) => {
  const data = {
    action: "update",
    value: { _id, upgradeDsrVersion, forceDeletedItemToManual },
    key: _id,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateList`, data);
  return response;
};

export const getAllVersionsOfDsr = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/getAllVersionsOfDsr`, data);
  return response;
};

export const getCostDatabase =
  ({ _id, dsrVersionId }: any) =>
  async (dispatch: any) => {
    const data = { value: { _id, dsrVersionId } };
    const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/getDsrData`, data);
    if (response.data.status) {
      dispatch(setCostdatabaseAction(response.data.result[0]));
    }
  };

export const getCostDatabaseById = async ({ _id, dsrVersionId }: any) => {
  const data = { value: { _id, dsrVersionId } };
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/getDsrData`, data);
  return response;
};

export const clearCostDatabaseRedux = () => (dispatch: any) => {
  dispatch(setCostdatabaseAction({}));
};

export const publishCostDatabaseVersion = async ({ dsrId }: any) => {
  const data = { dsrId };
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/publishCostDatabaseVersion`, data);
  return response;
};

export const discardCostDatabaseDraftVersion = async ({ dsrId }: any) => {
  const data = { dsrId };
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/discardDraftVersion`, data);
  return response;
};

export const getEstimateTotal = async ({ estimateId, versionId }: any) => {
  const data = { estimateId, versionId };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateTotal`, data);
  return response;
};

export function getEstimateAdditionalCostTotal(data: any) {
  return async (dispatch: any) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateAdditionalCostTotal`, data);

    if (response.data.status) {
      dispatch(setAdditionalCostTotalAction(response.data.data));
    }
  };
}

export const updatedEstimateItemSerial = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/updatedEstimateItemSerial`, data);
  return response;
};

export const getPurchaseUnits = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/units/getPurchaseUnits`, data);
  return response;
};

export const checkIfDsrVersionIsLatest = async ({ estimateId }: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/checkIfDsrVersionIsLatest`, {
    estimateId,
  });
  return response;
};

export const fetchTakeoffsListAttachedToItem = async ({ itemId, estimateId, versionId }: any) => {
  const data = { itemId, estimateId, versionId };

  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/getTakeoffsListAttachedToItem`, data);
  return response;
};

export const saveItemInEstimate = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateItems`, data);
  return response;
};

export const rateAnalysisItemType = {
  COST_DATABASE: "Cost Database Item",
  MANUAL: "Manual Item",
  ADDITIONAL_CHARGE: "Additional Charge",
  TOTAL: "Total",
  SUB_TOTAL: "Sub Total",
  MARKETRATE: "Market Rate Item",
};

export const changeItemTypeInEstimate = async ({ itemId, estimateId }: any) => {
  const data = { itemId, estimateId };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/changeItemTypeInEstimate`, data);
  return response;
};

export const upgradeTakeOffAttachedQuery = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/upgradeTakeOffAttachedQuery`, data);
  return response;
};

export const removeTakeOffAttachedQuery = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/takeoffs/removeTakeOffAttachedQuery`, data);
  return response;
};

export const getEstimateItemsRemoteData = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateItemsRemote`, data);
  return response;
};

export const saveFileCalibrationToEstimate = async ({ fileVersionId, scale }: any) => {
  const data = {
    resourceId: fileVersionId,
    data: scale,
    type: userSettingsType.FILE_CALIBRATION,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/userSettings/saveUserSettings`, data);
  return response;
};

export const updateEstimateAttachedCostDatabase = async ({ estimateId, dsrId }: any) => {
  const data = {
    estimateId,
    dsrId: dsrId || null,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/updateCostDatbaseInEstimate`, data);
  return response;
};

export const updateEstimateData = async ({ estimateId, costIndex }: any) => {
  const data = {
    action: "update",
    value: { _id: estimateId, costIndex },
    key: estimateId,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/getEstimateList`, data);
  return response;
};

export const getMeasurementUnits = async (data: any) => {
  const response = await axiosWrapper.post(portalMeasurementUnitsUrl, data);
  return response;
};

export const getMeasurementsList = async (data: any) => {
  const response = await axiosWrapper.post(estimateMeasurementsUrl, data);
  return response;
};

export const saveEstimateGeneralSettings = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/saveEstimateSettings`, data);
  return response;
};

export const getEstimateNumberValueBasedOnSettings = (value: any, estimateData: any) => {
  const { decimalPlaces, digitGrouping, largeNumber } = estimateData.settings;
  return getNumberBasedOnSettings({ value, decimalPlaces, digitGrouping, largeNumber });
};

export const getTakeoffWizard = async (data: any) => {
  return await axiosWrapper.post(`${getBackendUrl()}/takeoffs/getTakeoffWizard`, data);
};

export const getTakeoffWizardResults = async (data: any) => {
  return await axiosWrapper.post(`${getBackendUrl()}/takeoffs/getTakeoffWizardMeasurements`, data);
};
